import { debounce } from 'data/function';
import { CloseEditorIfOpenedEvent } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderController';
import { ExecuteScriptActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/ExecuteScriptActionSettings';
import { DEFAULT_VARIABLES_NAMES } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderService';
import { ActionController, ACTION_UNDO_REDO_CHANGES } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionController';
import { BuilderFeatures } from '../../../BuilderFeatures';
import { VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
import '../Actions.scss';
export class ExecuteScriptActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', 'SidebarContentService', '$translate', 'CodeEditorService', '$rootScope', 'UndoRedoService', 'state', '$timeout', 'CurrentApplicationService', '$scope', 'typeOfAction', 'onOpenSchemaEditor'];
    constructor(close, action, $onStateChanged, SidebarContentService, $translate, CodeEditorService, $rootScope, UndoRedoService, state, $timeout, CurrentApplicationService, $scope, typeOfAction, onOpenSchemaEditor) {
        super(close, action, $onStateChanged, UndoRedoService, state, { $rootScope, $scope, typeOfAction, onOpenSchemaEditor });
        this.SidebarContentService = SidebarContentService;
        this.$translate = $translate;
        this.CodeEditorService = CodeEditorService;
        this.$rootScope = $rootScope;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.$timeout = $timeout;
        this.CurrentApplicationService = CurrentApplicationService;
        this.updateInputVariables = (event) => {
            const { detail: { data } } = event;
            this.action.settings.inputVariables = data;
            this.handleSaveAction();
        };
        this.onContinueToggle = async (event) => {
            const continueOnError = event.detail.checked;
            this.action.continueOnError = continueOnError;
            this.handleSaveAction();
        };
        this.variables = DEFAULT_VARIABLES_NAMES.map(label => ({ label, value: label }));
        this.isEditorOpened = false;
        this.handleReturnAutoSave = debounce(this.handleSaveAction, 800);
        this.init();
    }
    async init() {
        this.$scope.$watch('$ctrl.action.settings.outputVariable', (oldValue, newValue) => {
            this.$timeout(this.handleSaveAction.bind(this));
        });
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
        this.initializeListeners();
        this.updateActionInputVariables();
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
    }
    async initializeListeners() {
        const isBuilderUndoRedoActionEnabled = await BuilderFeatures.builderUndoRedoActionEnabled();
        if (isBuilderUndoRedoActionEnabled) {
            this.$rootScope.$on(ACTION_UNDO_REDO_CHANGES, () => this.updateActionInputVariables());
        }
    }
    updateActionInputVariables() {
        this.inputVariables = this.action.settings.inputVariables;
    }
    create() {
        return new ExecuteScriptActionSettings();
    }
    validateOutputVariable() {
        const isValid = this.checkRegexVariable();
        this.returnValueForm.returnValue.$invalid = isValid;
        this.returnValueForm.returnValue.$valid = !isValid;
        this.returnValueForm.returnValue.$setDirty();
    }
    handleSaveAction() {
        this.validateOutputVariable();
        this.save();
    }
    checkRegexVariable() {
        return this.action.settings.outputVariable
            && !this.action.settings.outputVariable.match(VARIABLE_VALIDATION_REGEX);
    }
    toggleCodeEditor() {
        switch (this.isEditorOpened) {
            case true:
                this.closeCodeEditor();
                this.isEditorOpened = false;
                break;
            case false:
                this.openCodeEditor();
                this.isEditorOpened = true;
                break;
        }
    }
    async openCodeEditor() {
        this.sidebarEditor = await this.CodeEditorService.openCodeEditor({
            code: this.action.settings.source,
            language: 'javascript',
            editorWasCreated: this.editorWasCreated.bind(this),
            SidebarContentService: this.SidebarContentService,
            onCodeEditorChange: ({ code }) => {
                this.action.settings.source = code;
            },
            onSaveSource: () => {
                this.handleSaveAction();
            },
        });
        const deregisterCloseEditorEvent = this.$rootScope.$on(CloseEditorIfOpenedEvent, () => {
            this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        });
        await this.sidebarEditor.closeDeferred.promise; // when code editor close
        deregisterCloseEditorEvent();
        this.isEditorOpened = false;
    }
    closeCodeEditor() {
        this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        this.sidebarEditor = undefined;
    }
    /**
     * Callback executed after code editor created
     * @param object - Code editor standalone
     */
    editorWasCreated({ editor }) {
        this.isMonacoLoading = false;
        setTimeout(() => {
            editor.layout();
        }, 500);
    }
    onInputTitleBlur() {
        this.isEditing = false;
        if (this.action.$title.length === 0) {
            this.action.$title = this.$translate.instant('builder-tabs-actions.executeScript.title');
            this.handleSaveAction();
        }
    }
    startEditingInputTitle() {
        const input = document.getElementById('execute-script-title');
        if (input) {
            input.focus();
        }
    }
}
ExecuteScriptActionController.$inject = ['close', 'action', '$onStateChanged', 'SidebarContentService', '$translate', 'CodeEditorService', '$rootScope', 'UndoRedoService', 'state', '$timeout', 'CurrentApplicationService', '$scope', 'typeOfAction', 'onOpenSchemaEditor'];
